import React, { useRef } from "react";
import { Button, Dropdown, message, notification, Tooltip } from "antd";
import {
  FileTextOutlined,
  UploadOutlined,
  DownloadOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";


import { useConfigQuery } from "../../../../queries/useConfig";
import CadastroFiscalService from "./CadastroFiscalService";


export default function BotaoExcelFiscal({ buscarCadastros }) {
  const inputRef = useRef(null);

  const { data: config } = useConfigQuery();

  const abrirImportacao = () => {
    inputRef.current?.click();
  };

  const importarExcel = async (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    const nomeArquivo = file.name.toLowerCase();

    if (
      !nomeArquivo.endsWith(".xlsx") &&
      !nomeArquivo.endsWith(".xls")
    ) {
      message.error("Selecione uma planilha Excel (.xlsx ou .xls).");
      event.target.value = "";
      return;
    }

    try {
      const formData = new FormData();
      formData.append("arquivo", file);
      formData.append("idLoja", config.idLoja); // ou config.idLoja, conforme seu hook

      await CadastroFiscalService.importarExcel(formData);

      notification.success({
        message: "Cadastro fiscal importado com sucesso!",
        description: "A planilha foi importada com sucesso.",
      });

      buscarCadastros?.(); // Atualiza a tabela, se a função foi passada
    } catch (err) {
      console.error(err);

      notification.error({
        message: "Erro ao importar planilha.",
        description:
          err?.response?.data?.message ||
          "Ocorreu um erro ao importar o cadastro fiscal.",
      });
    } finally {
      event.target.value = "";
    }
  };

  const exportarExcel = async () => {
    try {
      const response = await CadastroFiscalService.exportarExcel(config.idLoja);

      const blob = new Blob(
        [response.data],
        {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }
      );

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "cadastro-fiscal.xlsx";

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      notification.success({
        message: "Cadastro fiscal exportado com sucesso!",
      });
    } catch (err) {
      console.error(err);

      notification.error({
        message: "Erro ao exportar planilha.",
        description:
          err?.response?.data?.message ||
          "Ocorreu um erro ao exportar o cadastro fiscal.",
      });
    }
  };

  const menu = {
    items: [
      {
        key: "1",
        icon: <UploadOutlined />,
        label: "Importar Excel",
        onClick: abrirImportacao,
      },
      {
        key: "2",
        icon: <DownloadOutlined />,
        label: "Exportar Excel",
        onClick: exportarExcel,
      },
    ],
  };

  return (
    <>
      <Tooltip title="Importar / Exportar Cadastro Fiscal">
        <Dropdown menu={menu} trigger={["click"]}>
          <Button
            type="primary"
            icon={<FileExcelOutlined />}
            style={{
              backgroundColor: "#000",
              borderColor: "#000",
              color: "#fff",
            }}
          />
        </Dropdown>
      </Tooltip>

      <input
        ref={inputRef}
        type="file"
        accept=".xlsx,.xls"
        style={{ display: "none" }}
        onChange={importarExcel}
      />
    </>
  );
}